import React, { useEffect, useState } from "react";
import Breadcrumb from "../../../components/Breadcrumb";
import { DASHBOARD, SOCIETY_BRAND, SOCIETY_CONTROLLER } from "../../../Routing/routes";
import InvoiceListLayer from "./Component/InvoiceListLayer";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { getBrandsList } from "../../../redux/actions/SocietyController/CtrlBrandAction/CtrlBrand";

const columns = [
    { id: "slNo", label: "#", sort: false, width: "50px" },
    { id: "id", label: "Brand ID", sort: true, width: "120px" },
    { id: "type", label: "Brand Code", sort: true, width: "200px" },
    { id: "title", label: "Brand Title", sort: true, width: "200px" },
    { id: "description", label: "Brand Description", sort: true, width: "200px" },
    // { id: "", label: "Flat & Members", sort: false, width: "130px" },
    { id: "createdAt", label: "Created Date", sort: true, width: "150px" },
    { id: "status", label: "Status", sort: true, width: "100px" },
    { id: "action", label: "Action", sort: false, width: "100px" },
];

const Brand = () => {
    const links = [{ to: SOCIETY_BRAND, text: 'Community Brand' }]
    const { loading, brandData } = useSelector(state => state.CtrlBrandReducers)

    const dispatch = useDispatch()
    const [searchQuery, setSearchQuery] = useState({ page: 1, limit: 10, search: '', status: null })

    // eslint-disable-next-line no-unused-vars
    const _handlePageChange = (currentPage) => {
        if (searchQuery.page !== currentPage) {
            setSearchQuery({ ...searchQuery, page: currentPage })
        }
    }
    // eslint-disable-next-line no-unused-vars
    const _handleLimitChange = (e) => {
        setSearchQuery({ ...searchQuery, page: 1, limit: e.target.value })
    }
    // eslint-disable-next-line no-unused-vars
    const _handleSearch = (e) => {
        e.preventDefault();
        setSearchQuery({ ...searchQuery, page: 1, search: e.target.value })
    }
    // eslint-disable-next-line no-unused-vars
    const _handleStatusChange = (e) => {
        setSearchQuery({ ...searchQuery, page: 1, status: e.target.value })
    }
    // eslint-disable-next-line no-unused-vars
    const _handleRefresh = () => {
        setSearchQuery({ ...searchQuery, page: 1, search: '', status: null })
    }

    const getTableData = () => {
        dispatch(getBrandsList({
            page: searchQuery?.page || 1,
            limit: searchQuery?.limit || 10,
            search: searchQuery?.search || '',
            status: searchQuery?.status || null,
        }))
    }
    useEffect(() => {
        getTableData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchQuery]);
    return (
        <>
            <Breadcrumb description='View and Manage Community Brand' links={links} headingTitle="Community Brand" title="CRM" to={SOCIETY_CONTROLLER + DASHBOARD} />
            <InvoiceListLayer data={brandData?.data?.length ? brandData?.data?.map((item, index) => {
                return {
                    slNo: index + 1 + Number((brandData?.meta?.pagination?.page - 1) * brandData?.meta?.pagination?.limit),
                    id: item.brand_id,
                    type: item?.brand_code,
                    title: item.name,
                    description: item.description,
                    logoUrl: item?.logo_url,
                    createdAt: item.created_at,
                    status: item.is_active,
                    website: item?.website,
                    action: item.society_id
                };
            }) : []} columns={columns} page={brandData?.meta?.pagination?.page || 1} limit={brandData?.meta?.pagination?.limit || 10} total={brandData?.meta?.pagination?.total} loading={loading} getTableData={getTableData} searchQuery={searchQuery} setSearchQuery={setSearchQuery} />
        </>
    );
};

export default Brand;
